/* eslint-disable no-continue */
/* eslint-disable no-await-in-loop */
/*
 * @Author:
 * @LastEditTime: 2022-10-26 17:48:28
 * @Description:
 */
/**
 * @description: 加载杆塔模型
 * @param {*} towerModelList 杆塔位号数据集合
 * @param {*} player player示例化对象
 * @return {*}
 */
const addTowerModel = async (player, towerModelList) => {
  const towerNodePtrs = [] // 杆塔名称和杆塔节点的映射集合
  for (let index = 0; index < towerModelList.length; index += 1) {
    const res = towerModelList[index]
    const node = await PlayerUtils.call(
      player.Native.NodeProxy.loadNode,
      `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/tower/${res.tagAttrList.MXMC}`,
      [],
      res.code,
      res.code
    )
    player.Native.NodeProxy.setNodeClampOffset(node, 0)
    player.Native.NodeProxy.setNodeGisPos(node, [res.tagAttrList.JD, res.tagAttrList.WD, 0])
    // 设置绕Z轴,Y轴,X轴自转
    const mat = await player.Native.NodeProxy.globalRSTransform(node)
    const zAxis = Matrix4.multiplyPos(mat, [0, 0, 1])
    const yAxis = Matrix4.multiplyPos(mat, [0, 1, 0])
    const xAxis = Matrix4.multiplyPos(mat, [1, 0, 0])
    player.Native.NodeProxy.rotate(node, zAxis, res.tagAttrList.ZXZJD)
    player.Native.NodeProxy.rotate(node, yAxis, res.tagAttrList.YXZJD)
    player.Native.NodeProxy.rotate(node, xAxis, res.tagAttrList.XXZJD)
    towerNodePtrs.push({
      name: res.code,
      value: node,
    })
  }
  return towerNodePtrs
}
/**
 * @description: 杆塔连线
 * @param {*} towerLineList 杆塔线缆位号数据集合(该方法必须在加载杆塔之后执行)
 * @param {*} towerNodePtrs 杆塔对象映射集合
 * @param {*} player player示例对象
 * @return {*}
 */
const addTowerLine = async (player, towerLineList, towerNodePtrs) => {
  // 线缆类别和颜色的映射集合
  const colorList = [
    {
      name: 'A',
      color: 0xffff00ff,
    },
    {
      name: 'B',
      color: 0x00ff00ff,
    },
    {
      name: 'C',
      color: 0xff0000ff,
    },
    {
      name: '避雷线',
      color: 0x000000ff,
    },
  ]
  _.forEach(towerLineList, async (item, index) => {
    // 获取起始杆塔指针对象
    const startTower = _.find(towerNodePtrs, ['name', item.tagAttrList.QSGTMC]).value
    // 获取起始绝缘子串对象
    const startTowerItem = await PlayerUtils.call(
      player.Native.NodeProxy.findSubNodeByName,
      startTower,
      item.tagAttrList.QSJYZCBH
    )
    // 获取终止杆塔指针对象
    const endTower = _.find(towerNodePtrs, ['name', item.tagAttrList.ZZGTMC]).value
    // 获取终止绝缘子串对象
    const endTowerItem = await PlayerUtils.call(
      player.Native.NodeProxy.findSubNodeByName,
      endTower,
      item.tagAttrList.ZZJYZCBH
    )
    // 当前连线的颜色
    const color = _.find(colorList, ['name', item.tagAttrList.XX]).color
    // 连线
    const lineId = await PlayerUtils.call(
      player.Native.NodeProxy.addWire,
      startTowerItem.nodePtr,
      endTowerItem.nodePtr,
      color
    )
    towerNodePtrs.push({
      name: item.code,
      value: lineId,
    })
  })
  return towerNodePtrs
}
/**
 * @description: 杆塔的定位移动
 * @param {*} code 杆塔相关位号code
 * @param {*} towerNodePtrs 杆塔对象映射集合
 * @return {*}
 */
const getTowerLocation = async (player, code, towerNodePtrs) => {
  const currentPtr = _.find(towerNodePtrs, ['name', code])
  // 根据指针获取杆塔aabb
  if (currentPtr) {
    // 获取杆塔世界坐标位置
    const globalPos = await player.Native.NodeProxy.globalTranslation(currentPtr.value)
    // 获取杆塔包围盒
    const aabb = await player.Native.NodeProxy.getAabb(currentPtr.value)
    // 计算包围盒的中心点
    const aabbCenter = Vec3.multiplyScalar(Vec3.add(aabb[0], aabb[1]), 0.5)
    // 计算MinMax向量
    const aabbMinVec = Vec3.sub(aabb[0], aabbCenter)
    const aabbMaxVec = Vec3.sub(aabb[1], aabbCenter)
    // 获取包围盒中心点与杆塔当前世界坐标
    const aabbOffset = Vec3.sub(aabbCenter, globalPos)

    // 杆塔世界坐标位置转换为经纬度坐标
    const llh = await player.Native.GisPlatform.worldToLLH(globalPos)
    // 经纬度
    const ll = [llh[0], llh[1]]
    // 根据经纬度坐标查询真实高程
    const realH = await player.Native.GisPlatform.queryDEM([ll])
    // 使用真实高程转换为世界坐标
    const realWorld = await player.Native.GisPlatform.llhToWorld([llh[0], llh[1], realH[0]])

    // 计算真实的aabb中心点
    const realAabbCenter = Vec3.add(realWorld, aabbOffset)
    // 计算真实的aabb MinMax
    const realAabbMin = Vec3.add(realAabbCenter, aabbMinVec)
    const realAabbMax = Vec3.add(realAabbCenter, aabbMaxVec)
    // 真实包围盒
    const realAabb = [realAabbMin, realAabbMax]
    // 定位到包围盒
    player.Native.Camera.moveToAabbWithFace(realAabb, 1.0, 1)
    // const aabb = await player.Native.NodeProxy.getAabb(currentPtr.value)
    // player.Native.Camera.moveToAabbWithFace(aabb, 1, 1)
  }
}
/**
 * @description: 通过item查找杆塔模型,1.如果是杆塔或杆塔子节点，则返回对应的杆塔模型item,2.如果是杆塔子节点，则isChild标识为true
 * @param {*} player
 * @param {*} item 杆塔对象的item
 * @param {*} towerNodePtrs 杆塔对象映射集合
 * @return {*}
 */
const findTower = async (player, item, towerNodePtrs) => {
  let isChild = false
  // 递归循环取最近出现的父节点的code
  while (item !== 0) {
    const itemInfo = await player.Native.ModelTree.getItemInfo(item)
    if (_.find(towerNodePtrs, ['value', itemInfo.nodePtr])) {
      return {
        item,
        code: itemInfo.code,
        isChild,
      }
    }
    item = itemInfo.parentItem
    isChild = true
  }
  return {
    item: 0,
  }
}
/**
 * @description:
 * @param {*} player
 * @param {*} pipeModelData 管道树结构数据集合
 * @param {*} pipeAndModelMap 管道模型和普通模型的指针映射集合
 * @return {*}
 */
const addPipeModel = async (player, pipeModelData, pipeAndModelMap) => {
  // 监听鼠标左键点击事件
  player.Native.GisMarker.EventGisMarkerLClick.connect(async (res) => {
    // 获取点击的管道对象
    const pipeObject = await PlayerUtils.call(
      player.Native.DisplayPipeCreator.findPipeObjectByMarkNode,
      res.markerId
    )
    // 摄像机定位到目标
    player.Native.DisplayPipeCreator.moveToPipeObject(pipeObject, 1.0)
  })
  // 创建图标
  const createIconRes = await PlayerUtils.call(
    player.Native.DisplayPipeCreator.createIcon,
    'data://location.png'
  )
  const pipeArray = []
  let pipe = null
  for (let p = 0; p < pipeModelData.length; p += 1) {
    pipe = pipeModelData[p]
    let corner = null
    let cornerNext = null
    let word = null
    let wordNext = null
    let xOff = null
    let yOff = null
    let zOff = null
    for (let c = 0; c < pipe.children.length; c += 1) {
      cornerNext = null
      corner = pipe.children[c]
      // 经纬度坐标转换为三维笛卡尔空间坐标
      word = await PlayerUtils.call(player.Native.GisPlatform.llhToWorld, corner.position)
      if (corner.children && c < pipe.children.length - 1) {
        cornerNext = pipe.children[c + 1]
        // 经纬度坐标转换为三维笛卡尔空间坐标
        wordNext = await PlayerUtils.call(player.Native.GisPlatform.llhToWorld, cornerNext.position)
        xOff = word[0] - wordNext[0]
        yOff = word[1] - wordNext[1]
        zOff = word[2] - wordNext[2]
        let distance = Math.sqrt(xOff * xOff + yOff * yOff + zOff * zOff)
        distance = distance / (corner.children.length + 1)
        for (let w = 0; w < corner.children.length; w += 1) {
          corner.children[w].distance = corner.children[w].distance || distance * (w + 1)
        }
      }
    }
  }
  const pipePionterArray = []
  // 批量创建管道
  for (let pipeIndex = 0; pipeIndex < this.pipeModelData.length; pipeIndex += 1) {
    // 创建管道
    const pipeArrayWithPtr = await PlayerUtils.call(player.Native.DisplayPipeCreator.createPipes, [
      this.pipeModelData[pipeIndex],
    ])
    pipePionterArray.push(pipeArrayWithPtr[0].pointer)
  }
  // 批量更新管道
  player.Native.DisplayPipeCreator.updatePipes(pipePionterArray, 5000, 0)
  // 动态获取管道模型唯一标示指针和fileid做映射
  pipeAndModelMap = _.concat(
    pipeAndModelMap,
    _.map(pipePionterArray, (val) => {
      return {
        name: val,
        fileId: item.fileId,
        fileName: item.name,
      }
    })
  )
  return pipeAndModelMap
}
/**
 * @description: 通过code的变化移动到指定的管道模型位置
 * @param {*} player
 * @param {*} code 管道相关位号code
 * @return {*}
 */
const getPipeTagsLoction = async (player, code) => {
  player.Native.DisplayPipeCreator.findPipeObjectByName(code, (res) => {
    player.Native.DisplayPipeCreator.moveToPipeObject(res, 1.0)
    // player.Native.DisplayPipeCreator.weldingPointPosition(res, (result) => {
    //   console.log((result[0] * 180) / Math.PI, (result[1] * 180) / Math.PI, 55555555555)
    // })
  })
}
/**
 * @description: 点选定位的功能方法(适合模型树的)
 * @param {*} player
 * @param {*} data 模型树点击的对象
 * @return {*}
 */
const multipleLocations = async (player, data, isSelect = true) => {
  // 高亮选中的模型
  if (isSelect) {
    await player.Native.Node.selectNodes([data.node])
  }
  // 计算获取到模型树item的aabb
  const nodeData = await player.Native.Node.getProperty(data.node, ['aabb'])
  const result = nodeData.aabb
  // 判断是否打开地球
  const isGis = await player.Native.GisPlatform.isGisMode()
  console.log('是否打开地球', isGis)
  if (!isGis) {
    // 如果未打开地球，则用常规定位方式
    const aabbtmp = [result[0], result[1]]
    await player.Native.Camera.moveToAabbWithFace(aabbtmp, 2, 0)
  } else {
    // 打开地球，需要考虑到模型的地形攀爬，防止摄像机定位过去之后位置在地面以下
    let bFind = false // 是否查找到具有gisTransform的祖先item
    let isChild = false // 当前点击的item是否是具有gisTransform item的子
    let toAabb = [] // 将要用来做最终定位的aabb
    let fItem = data.node // while 向上查询的临时变量
    while (fItem !== 0) {
      const iteminfos = await player.Native.Node.getProperty(fItem, ['name', 'code', 'localTrans', 'localRot', 'localScale', 'globalTrans', 'globalRot', 'parent', 'children', 'visible', 'material', 'aabb'])
      // gisTransform属性只能从节点对象中获取，因此，如果这里节点对象为0，则表明该item肯定不含有gisTransform
      if (!iteminfos.node || iteminfos.node) {
        fItem = iteminfos.parent
        isChild = true
        continue
      }
      // const nodeGisPos = await PlayerUtils.call(
      //   player.Native.NodeProxy.nodeGisPos,
      //   iteminfos.nodePtr
      // )
      const nodeGisPos = iteminfos.localTrans
      // 获取加载模型时设置的gisPos(即个isTransform信息)，如果该pos为空数组，表示当前item不含有gisTransform属性
      if (!nodeGisPos.length) {
        fItem = iteminfos.parent
        isChild = true
        continue
      }
      // 获取到了gisPos， 用gisPos中的经纬度查询实际高程
      const realH = await player.Native.GisPlatform.queryDEM([
        [nodeGisPos[0], nodeGisPos[1]],
      ])
      // 使用查询到的高程与gisPos组成经纬高构造 gisTransform矩阵
      const realGisTransform = await player.Native.GisPlatform.makeGisTransform([
        nodeGisPos[0],
        nodeGisPos[1],
        realH[0],
      ])
      // 使用 gisTransform矩阵变换 模型对象的localAabb，从而得到实际需要定位的aabb
      toAabb[0] = result.localAabb[0]
      toAabb[1] = result.localAabb[1]

      toAabb = await player.Native.Camera.transformAabb(toAabb, realGisTransform)
      bFind = true
      break
    }
    // 这里判断相机朝向是否需要改变，通过from和to两个位置的up向量的夹角大于一定门限来判断
    let faceIndex = 1
    const camCurParam = await player.Native.Camera.currentParam()
    let v0 = camCurParam.eye
    let v1 = Vec3.multiplyScalar(Vec3.add(result.aabb[0], result.aabb[1]), 0.5)
    v0 = Vec3.normalize(v0)
    v1 = Vec3.normalize(v1)
    const angle = Vec3.angleBetween(v0, v1)
    // 如果夹角小于 1.5° ，则摄像机不用改变视角，只需要平移到目标包围盒
    if (angle < 1.5) {
      faceIndex = 0
    }
    // 执行定位
    if (bFind) {
      player.Native.Camera.moveToAabbWithFace(toAabb, 2, faceIndex)
    } else {
      const aabbtmp = [result[0], result[1]]
      player.Native.Camera.moveToAabbWithFace(aabbtmp, 2, faceIndex)
    }
  }
}
// 获取广告牌图片
const checkAddPic = async (name, item, player, fullToken) => {
  if (!item.flatImageUrl) {
    return
  }
  await player.Native.File.downloadFile(
    `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.Md5}/${name}.jpg`,
    'GET',
    `${currentEnv.VUE_APP_PLANT_SERVER}${item.flatImageUrl}`,
    {
      Authorization: `${fullToken}`,
    },
    (res) => {
      // 代表创建下载任务成功
      if (res) {
        console.log(name, item, res)
      }
    }
  )
}
/**
 * @description: 放置广告牌
 * @param {*}
 * @return {*}
 */

const addBoardNode = async (
  name,
  url,
  item,
  player,
  checkModelLoad,
  checkModelLoadEnd,
  fullToken
) => {
  player.Native.Model.EventProgress.connect(checkModelLoad)
  player.Native.Model.EventProgressEnd.connect(checkModelLoadEnd)
  const res = await player.Native.NodeProxy.loadNode(url, [], `${name}`, `${name}`)
  item.nodeCode = res // 给指针赋值
  if (item.content !== '' && JSON.parse(item.content)) {
    const moveForm = JSON.parse(item.content).moveForm
    const rotateForm = JSON.parse(item.content).rotateForm
    const zoomForm = JSON.parse(item.content).zoomForm
    if (moveForm && rotateForm && zoomForm) {
      await player.Native.NodeProxy.setGlobalTranslation(res, [moveForm.x, moveForm.y, moveForm.z])
      await player.Native.NodeProxy.setNodeRotation(res, [rotateForm.x, rotateForm.y, rotateForm.z])
      await player.Native.NodeProxy.setNodeScaling(res, [zoomForm.x, zoomForm.y, zoomForm.z])
    }
  }
  if (!JSON.parse(item.content).newName) {
    const obj1 = JSON.parse(item.content)
    console.log(obj1)
    obj1.newName = `${item.merchantName}${Math.round(Math.random() * 80 + 20)}`
    item.content = JSON.stringify(obj1)
  }
  await checkAddPic(JSON.parse(item.content).newName, item, player, fullToken)
  const obj = await player.Native.ModelTree.getItemByCode(item.merchantId)
  if (obj && obj.nodePtr) {
    const child = await player.Native.NodeProxy.getNodeChildren(obj.nodePtr)
    const materialPtr = await player.Native.NodeProxy.getNodeMatrix(child[0].nodePtr)
    if (materialPtr) {
      const copyMaterial = await player.Native.NodeProxy.copyMaterial(materialPtr)
      await player.Native.NodeProxy.setNodeMaterial(child[0].nodePtr, copyMaterial)
      console.log(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${
          JSON.parse(item.content).newName
        }.jpg`
      )
      await player.Native.NodeProxy.setMaterialTexture(
        copyMaterial,
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${
          JSON.parse(item.content).newName
        }.jpg`
      )
    }
  }
  return true
}

/**
 * @description: 模型树节点类型的枚举
 * @param {*}
 * @return {*}
 */
const modelTreeObj = {
  ITEM_PR: 0, // PR 文件节点类型
  ITEM_NODE: 1, // CELLNode文件节点类型
  ITEM_GISOBJ: 2, // gis 数据对象
  ITEM_NULL: 3, // 仅仅对根节点使用
}
/**
 * @description:
 * @param {*} data
 * @param {*} key1
 * @param {*} key2
 * @return {*}
 */
const setLocalStorage = async (data, key1, key2) => {
  let res = (await LocalForage.getItem(key1)) || {}
  key2 ? (res[key2] = data) : (res = data)
  LocalForage.setItem(key1, res)
}
export {
  addTowerModel,
  addTowerLine,
  getTowerLocation,
  addPipeModel,
  getPipeTagsLoction,
  multipleLocations,
  findTower,
  addBoardNode,
  checkAddPic,
  modelTreeObj,
  setLocalStorage,
}
